namespace TabAurous.Retail {
    export interface ReceiptDenominationDetailsRow {
        ReceiptDetailsId?: number;
        ReceiptId?: number;
        DenominationId?: number;
        Code?: number;
        Count?: number;
        Amount?: number;
    }

    export namespace ReceiptDenominationDetailsRow {
        export const idProperty = 'ReceiptDetailsId';
        export const localTextPrefix = 'Retail.ReceiptDenominationDetails';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            ReceiptDetailsId = "ReceiptDetailsId",
            ReceiptId = "ReceiptId",
            DenominationId = "DenominationId",
            Code = "Code",
            Count = "Count",
            Amount = "Amount"
        }
    }
}
